import { render, staticRenderFns } from "./discountDetail.vue?vue&type=template&id=7663adcc&scoped=true&"
import script from "./discountDetail.vue?vue&type=script&lang=js&"
export * from "./discountDetail.vue?vue&type=script&lang=js&"
import style0 from "./discountDetail.vue?vue&type=style&index=0&id=7663adcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7663adcc",
  null
  
)

export default component.exports